import { SVGProps } from "react"
const RoomsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.2402 12.1536H0.759766V16.9998H19.2402V12.1536Z"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.2135 8.9231H1.78646C1.22178 8.9231 0.759766 9.40772 0.759766 10V12.1539H19.2402V10C19.2402 9.40772 18.7782 8.9231 18.2135 8.9231Z"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.85843 6.23047H5.47138C4.85537 6.23047 4.35742 6.75279 4.35742 7.39896V8.92284H8.97753V7.39896C8.97753 6.75279 8.47958 6.23047 7.86357 6.23047H7.85843Z"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5323 6.23047H12.1452C11.5292 6.23047 11.0312 6.75279 11.0312 7.39896V8.92284H15.6514V7.39896C15.6514 6.75279 15.1534 6.23047 14.5374 6.23047H14.5323Z"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1862 8.92321V4.07695C17.1862 3.48463 16.7241 3 16.1595 3H3.83919C3.27451 3 2.8125 3.48463 2.8125 4.07695V8.92321"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default RoomsIcon
